// extracted by mini-css-extract-plugin
export default {"applypage":"ApplypageMobile_applypage__pZhqE","applypageMobile":"ApplypageMobile_applypageMobile__NPM+E"};